import Swal from "sweetalert2";
import store from "@/store";

export default class Dialog{

    static format(baeString: string, ...params: any[]){
        let i = 0
        for(const param of params){
            baeString = baeString.replace('{' + i +'}', param)
            i++
        }
        return baeString
    }

    static async confirm(message: string, width?: string, focusCancel?: boolean){
        const result = await Swal.fire({
            title: '<span class="fs-5">日本歯科衛生協会</span>',
            html: message,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            cancelButtonText: 'いいえ',
            confirmButtonText: 'はい',
            focusCancel: focusCancel ? focusCancel : false,
            width: width ? width : '500px'
        })
        return result.isConfirmed && !result.isDismissed
    }

    static alert(message: string){
        Swal.fire(
            {
                title: '<span style="color:orange">' + message + '</span>',
                icon: 'warning',
                width: '800px'
            }
        )
    }
    static info(message: string){
        Swal.fire(
            {
                title: message,
                icon: 'info',
                width: '800px'
            }
        )
    }
    static success(message: string){
        Swal.fire(
            {
                title: message,
                icon: 'success',
            }
        )
    }
}
